/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import I18n from 'I18n';
import { userInfoSync } from 'hub-http/userInfo';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import UILink from 'UIComponents/link/UILink';
import { LinkTypes } from '../../constants/link';
import { formatUserName, getSetupMeetingLinkUrl, getAlphabeticalSortPrioritizingUser } from '../../utils/link';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.links.linkTypes.${LinkTypes.MEETING}.${suffix}`;
const getMeetingDisplay = (meeting, formattedUserName) => meeting.name || I18n.text(i18nKey('defaultName'), {
  user: formattedUserName
});
export default class MeetingLinkField extends PureComponent {
  constructor(...args) {
    super(...args);
    this.handleChange = ({
      target: {
        value
      }
    }) => {
      this.props.onChange({
        url: value.options.url,
        meetingName: value.options.label
      });
    };
    this.fetchMeetingLinks = (_input, callback) => {
      this.props.fetchMeetingsByUsers().then(meetingsByUser => {
        const options = meetingsByUser.map(user => ({
          text: formatUserName(user),
          userId: user.id,
          options: user.meetings.map(meeting => ({
            help: meeting.link,
            value: meeting.link,
            userId: meeting.userId,
            text: getMeetingDisplay(meeting, formatUserName(user)),
            options: {
              label: getMeetingDisplay(meeting, formatUserName(user)),
              url: meeting.link
            },
            id: meeting.id
          }))
        }));
        if (!options.length) {
          options.push({
            text: I18n.text(i18nKey('noMeetingsTitle')),
            disabled: true,
            help: /*#__PURE__*/_jsx(UILink, {
              href: getSetupMeetingLinkUrl(),
              external: true,
              children: I18n.text(i18nKey('noMeetingsHelp'))
            })
          });
        } else {
          options.sort(getAlphabeticalSortPrioritizingUser(this.userId));
        }
        callback(null, {
          options
        });
      });
    };
  }
  componentDidMount() {
    if (this.props.userId) {
      this.userId = this.props.userId;
    } else {
      try {
        const {
          user
        } = userInfoSync();
        this.userId = user.user_id;
      } catch (error) {
        // DO NOTHING - all this means is that we cannot prioritize
        // the current user in the sorted meeting link list
      }
    }
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    const {
      url,
      dropdownClassName
    } = this.props;
    return /*#__PURE__*/_jsx(UIFormControl, {
      label: I18n.text(i18nKey('label')),
      className: "m-top-0",
      children: /*#__PURE__*/_jsx(UISelect, {
        dropdownClassName: dropdownClassName,
        searchable: true,
        filterOptions: true,
        value: url,
        loadOptions: this.fetchMeetingLinks,
        onSelectedOptionChange: this.handleChange,
        placeholder: I18n.text(i18nKey('placeholder'))
      })
    });
  }
}
MeetingLinkField.propTypes = {
  userId: PropTypes.number,
  fetchMeetingsByUsers: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  url: PropTypes.string,
  dropdownClassName: PropTypes.string
};